
<!-- Header Navbar -->
<nav class="main-header navbar navbar-expand navbar-white navbar-light">
	<!-- Sidebar toggle button-->
	<ul class="navbar-nav">
		<li class="nav-item">
			<a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
		</li>
		<!-- <li class="nav-item d-none d-sm-inline-block">
			<a href="index3.html" class="nav-link">Home</a>
		</li> -->
	</ul>
	<ul class="navbar-nav ml-auto">

		<li class="nav-item dropdown changeLanguage"></li>
		
		<!-- Messages: style can be found in dropdown.less-->
		<!-- <li class="btn-secondary dropdown-toggle changeLanguage">
		</li> -->

		<!-- <li class="nav-item dropdown" *ngIf="display_messages">
			<a class="nav-link" data-toggle="dropdown" href="#" aria-expanded="false" role="button">
				<i class="far fa-comments"></i>
				<span class="badge badge-danger navbar-badge">3</span>
			</a>
		</li>
		 -->
		<!-- Messages: style can be found in dropdown.less-->
		<!-- <li class="nav-item dropdown messagesBox" *ngIf="display_messages"></li> -->
		<!-- Notifications Menu -->
		<li class="nav-item dropdown notifications-menu notificationsBox" *ngIf="display_notifications"></li>
		<!-- Tasks Menu -->
		<!-- <li class="nav-item dropdown tasks-menu tasksBox" *ngIf="display_tasks"></li> -->
		<!-- User Account Menu -->
		<li class="nav-item dropdown user user-menu userBox" *ngIf="display_user"></li>
		<!-- Dark mode toggle -->
		<li class="nav-item">
			<span class="nav-link dm-toggle-wrap">
				<button type="button" class="dm-toggle" [class.is-dark]="isDark" role="switch"
						[attr.aria-checked]="isDark" aria-label="Alternar modo escuro" (click)="toggleDarkMode()">
					<i class="dm-toggle__icon dm-toggle__icon--sun fas fa-sun"></i>
					<i class="dm-toggle__icon dm-toggle__icon--moon fas fa-moon"></i>
					<span class="dm-toggle__thumb"></span>
				</button>
			</span>
		</li>
		<!-- Additionnal components -->
		<!-- <ng-container *ngFor="let widget of header_components">
			<li>
				<app-component-loader [class_component]="widget.class"
					[data]="widget.data"></app-component-loader>
			</li>
		</ng-container> -->


	</ul>
</nav>
